import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const Partners = () => {
  const partnerLogos = [
    { name: 'Amazon', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg', size: 'normal' },
    { name: 'Target', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Target_logo.svg', size: 'normal' },
    { name: 'Kroger', logo: 'https://customer-assets.emergentagent.com/job_eyme-selling-partner/artifacts/sm6pbz56_kroger.png', size: 'normal' },
    { name: 'Best Buy', logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f5/Best_Buy_Logo.svg', size: 'normal' },
    { name: 'Costco', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/59/Costco_Wholesale_logo_2010-10-26.svg', size: 'normal' },
    { name: 'The Home Depot', logo: 'https://customer-assets.emergentagent.com/job_eyme-selling-partner/artifacts/10kh4k0w_the%20home%20depot.png', size: 'normal' },
    { name: 'Alibaba', logo: 'https://customer-assets.emergentagent.com/job_eyme-selling-partner/artifacts/tflyvxp5_alibaba.png', size: 'normal' },
    { name: 'Walmart', logo: 'https://customer-assets.emergentagent.com/job_eyme-selling-partner/artifacts/ckm4jlf9_walmart.png', size: 'large' }
  ];

  const benefits = [
    {
      title: 'Strategic Growth',
      description: 'We work closely with manufacturers and distributors to develop customized growth strategies that align with your business goals.',
      icon: '📈'
    },
    {
      title: 'Market Expansion',
      description: 'Access to multiple marketplaces including Amazon, Walmart, and specialty platforms, expanding your reach to millions of customers.',
      icon: '🌍'
    },
    {
      title: 'Transparent Reporting',
      description: 'Real-time access to sales data, inventory levels, and performance metrics through our partner dashboard.',
      icon: '📊'
    },
    {
      title: 'Dedicated Support',
      description: 'Each partner is assigned a dedicated account manager who understands your products and business objectives.',
      icon: '🤝'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGdyb3d0aHxlbnwwfHx8fDE3NzIyNzA3MDB8MA&ixlib=rb-4.1.0&q=85)'
        }}
      >
        <div className="absolute inset-0 bg-slate-900/90"></div>
        <div className="container mx-auto px-6 relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-white text-center mb-6">
            Our <span className="text-[#FF9900]">Partners</span>
          </h1>
          <p className="text-xl text-gray-200 text-center max-w-3xl mx-auto">
            Collaborating with manufacturers, distributors, and brand owners to scale marketplace success
          </p>
        </div>
      </section>

      {/* Partner Description */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-slate-900 mb-6">
              Trusted <span className="text-[#FF9900]">Partnerships</span>
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed text-center mb-6">
              At EYME LLC, we believe in building lasting relationships with manufacturers, distributors, 
              and brand owners. Our partnership model is designed to help you succeed in the competitive 
              world of e-commerce without the complexity and risk traditionally associated with online selling.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed text-center">
              We work with a diverse range of partners across multiple industries, from consumer electronics 
              to home goods, sporting equipment to musical instruments. Whatever your product category, 
              we have the expertise and infrastructure to help you thrive on major marketplaces.
            </p>
          </div>
        </div>
      </section>

      {/* Partner Benefits */}
      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 mb-4 text-center">
            Partnership <span className="text-[#FF9900]">Benefits</span>
          </h2>
          <p className="text-center text-gray-600 mb-16 text-lg">
            Why leading brands choose to partner with EYME LLC
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {benefits.map((benefit, index) => (
              <Card 
                key={index} 
                className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <CardContent className="p-8">
                  <div className="text-5xl mb-4">{benefit.icon}</div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Partner Logos */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 mb-16 text-center">
            Platform <span className="text-[#FF9900]">Partners</span>
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {partnerLogos.map((partner, index) => (
              <div 
                key={index} 
                className="flex items-center justify-center p-8 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 border border-gray-100"
              >
                <img 
                  src={partner.logo} 
                  alt={partner.name} 
                  className={`${partner.size === 'large' ? 'max-h-28' : 'max-h-20'} max-w-full w-auto h-auto object-contain`}
                  style={{ filter: 'grayscale(100%)', transition: 'filter 0.3s ease' }}
                  onMouseEnter={(e) => e.target.style.filter = 'grayscale(0%)'}
                  onMouseLeave={(e) => e.target.style.filter = 'grayscale(100%)'}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-900">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to <span className="text-[#FF9900]">Partner</span> With Us?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Join over 2,000 vendors who trust EYME LLC to manage their Amazon marketplace presence. 
            Let's discuss how we can help your brand grow.
          </p>
          <a href="/contact">
            <button className="bg-[#FF9900] hover:bg-[#e68a00] text-white px-10 py-4 text-lg font-semibold rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105">
              Become a Partner
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Partners;
